import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import Button from "components/CustomButtons/Button.jsx";
import CircularProgress from '@material-ui/core/CircularProgress';
import ECCard from "components/EnergyCompany/Cards/ECCard.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Hidden from '@material-ui/core/Hidden';
import InputAdornment from '@material-ui/core/InputAdornment';
import LinearProgress from '@material-ui/core/LinearProgress';
import PropTypes from "prop-types";
import React, { Component } from "react";
import Select from "react-select";
import withStyles from "@material-ui/core/styles/withStyles";
import * as Animated from "react-select/lib/animated";
import { filter, find, isEmpty, isEqual, keys, round, times } from 'lodash';

import AutosuggestCNPJAsync from "components/EnergyCompany/Autosuggest/AutosuggestCNPJAsync";
import BouncingLoader from "components/EnergyCompany/BouncingLoader/BouncingLoader.jsx";
import buttonTransparentBlueBorder from "assets/EnergyCompany/jss/button-transparent-blue-border.jsx";
import CustomInput from "components/EnergyCompany/Input/Input";
import ResultadoSimuladorCativoLivre from "./partials/ResultadoSimuladorCativoLivre";
import { calcularEconomia, fetchDefaultParametros, getCativoInfo, getCompanyInfo } from "services/simulador";
import { removeNonDigits } from "services/utils";
import { sendMessage } from "services/contato";

const defaultStyleForSection = {
  display: "grid",
  gridColumnGap: "15px",
  gridRowGap: "15px",
  gridTemplateColumns: "1fr 1fr",
  padding: "10px",
  width: "100%",
};

const inputTextStyle = {
  border: "none",
  background: "#F6F6F6",
  borderRadius: "3px",
  height: "40px",
  padding: "0 10px",
};

const simuladorStyle = theme => ({
  autosuggest: {
    marginBottom: "50px",
  },
  loading: {
    marginTop: "25px",
  },
  infoWrapper: {
    ...defaultStyleForSection,
  },
  outrosWrapper: {
    ...defaultStyleForSection,
  },
  forceNewRowModifier: {
    gridColumnStart: "1",
  },
  calcularButtonWrapper: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "10px",
  },
  requiredFieldsError: {
    color: "red",
    display: "flex",
    justifyContent: "flex-end",
  },

  button: {
    ...buttonTransparentBlueBorder,
    gridColumnStart: 2,
  },
  disclaimer: {
    flex: 1,
    "& h4": {
      fontWeight: "bold",
    },
    "& p": {
      fontWeight: "400",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
      textAlign: "center",
    },
  },
  emailSentMessage: {
    gridColumnEnd: "span 2",
  },
  form: {
    flex: 1,
    display: "grid",
    gridGap: "15px",
    gridTemplateColumns: "1fr 1fr",
  },
  formCard: {
    backgroundColor: "white",
    borderRadius: "6px",
    display: "flex",
    padding: "50px",
    [theme.breakpoints.down("sm")]: {
      padding: "10px",
      display: "block",
    },
  },
  inputText: {
    ...inputTextStyle,
  },
  textarea: {
    ...inputTextStyle,
    gridColumn: "1 / span 2",
    height: "unset",
    padding: "10px",
  },
});

const tiposDeEnergia = [
  { id: "total", nome: "Total" },
  { id: "patamar", nome: "Patamar" },
];

class Simulador extends Component {
  state = {
    categoriaCNAE: {},
    cnpjDados: undefined,
    crescimentoAnualTarifaCativo: 0,
    custoEncargos: 0,
    demandaPontaKW: 0,
    demandaForaPontaKW: 0,
    desconto: {},
    distribuidora: {},
    energiaPonta: 0,
    energiaForaPonta: 0,
    energiaTotal: 0,
    error: undefined,
    percentualEnergiaProinfa: 0,
    custoRepresentacaoMensal: 0,
    loading: false,
    modalidade: {},
    parametros: {},
    precoLivreAno: 0,
    precoLivreAnoMais1: 0,
    precoLivreAnoMais2: 0,
    precoLivreAnoMais3: 0,
    previsaoIPCA: 0,
    resultadoEconomia: undefined,
    simulando: false,
    subgrupo: {},
    tarifaCCEEPorMWh: 0,
    tipoDeEnergia: tiposDeEnergia[1],
    unidadeEnergia: {},

    emailSentMessage: "",
    email: "",
    nome: "",
    msg: "",
    sending: false,
  };

  componentDidMount() {
    fetchDefaultParametros().then(({ data }) => {
      const unidadeEnergia = find(data.unidades, ['id', 1]);
      const desconto = find(data.descontosPerfisAgentes, ['id', 'convencional']);
      this.savePrecos(data.precosEnergiaLivrePorDescontoEAno, desconto);

      this.setState({
        crescimentoAnualTarifaCativo: data.crescimentoAnualTarifaCativo,
        custoRepresentacaoMensal: data.custoRepresentacaoMensal,
        desconto,
        parametros: data,
        percentualEnergiaProinfa: data.percentualEnergiaProinfa,
        previsaoIPCA: data.previsaoIPCA,
        tarifaCCEEPorMWh: data.tarifaCCEEPorMWh,
        unidadeEnergia,
       });
    });
  }

  componentDidUpdate(prevPros, prevState) {
    const { desconto, parametros, subgrupo } = this.state;
    const descontoMudou = !isEqual(prevState.desconto, desconto);
    const subgrupoMudou = !isEqual(prevState.subgrupo, subgrupo);

    if (descontoMudou) {
      this.savePrecos(parametros.precosEnergiaLivrePorDescontoEAno, desconto);
    }

    if (subgrupoMudou) {
      const { descontosPerfisAgentes, modalidadesTarifarias } = parametros;

      if (subgrupo.id === 'a3') {
        this.setState({
          desconto: find(descontosPerfisAgentes, ['id', 'convencional']),
          modalidade: find(modalidadesTarifarias, ['id', 'azul']),
        });
      }

      if (subgrupo.id === 'a4') {
        this.setState({
          desconto: find(descontosPerfisAgentes, ['id', 'i50']),
          modalidade: find(modalidadesTarifarias, ['id', 'verde']),
        });
      }
    }
  }

  savePrecos(precosEnergiaLivrePorDescontoEAno, desconto) {
    const precos = precosEnergiaLivrePorDescontoEAno[desconto.id];
    const precosKeys = keys(precos);

    this.setState({
      precoLivreAno: precos[precosKeys[0]],
      precoLivreAnoMais1: precos[precosKeys[1]],
      precoLivreAnoMais2: precos[precosKeys[2]],
      precoLivreAnoMais3: precos[precosKeys[3]],
     });
  }

  getInfoContent() {
    const { classes } = this.props;
    const { categoriaCNAE, cnpjDados, desconto, distribuidora, loading, modalidade, parametros, subgrupo } = this.state;
    const shouldDisable = !cnpjDados || loading;

    return (
      <div>
        <h3><b>Informações Gerais</b></h3>
        <div className={classes.infoWrapper}>
          <div>
            <h6>Distribuidora Sugerida*</h6>
            <Select
              components={Animated}
              getOptionLabel={option => option.nome}
              getOptionValue={option => option.id}
              isDisabled={shouldDisable}
              noOptionsMessage={() => "Carregando..."}
              onChange={option => this.setState({ distribuidora: option })}
              options={parametros.agentesDistribuidores || []}
              placeholder="Distribuidoras"
              value={distribuidora}
            />
          </div>
          <div>
            <h6>Subgrupo*</h6>
            <Select
              components={Animated}
              getOptionLabel={option => option.nome}
              getOptionValue={option => option.id}
              isDisabled={shouldDisable}
              noOptionsMessage={() => "Carregando..."}
              onChange={option => this.setState({ subgrupo: option })}
              options={parametros.subgrupos || []}
              placeholder="Subgrupos"
              value={subgrupo}
            />
          </div>
          <div>
            <h6>Modalidade Tarifaria*</h6>
            <Select
              components={Animated}
              getOptionLabel={option => option.nome}
              getOptionValue={option => option.id}
              isDisabled={shouldDisable}
              noOptionsMessage={() => "Carregando..."}
              onChange={option => this.setState({ modalidade: option })}
              options={parametros.modalidadesTarifarias || []}
              placeholder="Modalidades"
              value={modalidade}
            />
          </div>
          <div>
            <h6>Categoria CNAE*</h6>
            <Select
              components={Animated}
              getOptionLabel={option => option.nome}
              getOptionValue={option => option.id}
              isDisabled={shouldDisable}
              noOptionsMessage={() => "Carregando..."}
              onChange={option => this.setState({ categoriaCNAE: option })}
              options={parametros.categoriasCNAE || []}
              placeholder="Categorias"
              value={categoriaCNAE}
            />
          </div>
          <div>
            <h6>Desconto*</h6>
            <Select
              components={Animated}
              getOptionLabel={option => option.nome}
              getOptionValue={option => option.id}
              isDisabled={shouldDisable}
              noOptionsMessage={() => "Carregando..."}
              onChange={option => this.setState({ desconto: option })}
              options={parametros.descontosPerfisAgentes || []}
              placeholder="Categorias"
              value={desconto}
            />
          </div>
        </div>
      </div>
    );
  }

  getEnergia() {
    const { classes } = this.props;
    const { demandaPontaKW, demandaForaPontaKW, energiaPonta, energiaForaPonta, energiaTotal, modalidade, parametros, tipoDeEnergia, unidadeEnergia } = this.state;
    const { cnpjDados, loading } = this.state;
    const shouldDisable = !cnpjDados || loading;

    return (
      <div>
        <h3><b>Energia</b></h3>
        <div className={classes.outrosWrapper}>
          {modalidade.id !== 'verde' && (
            <div>
              <h6>Demanda ponta</h6>
              <CustomInput
                disabled={shouldDisable}
                onChange={({ target }) => this.setState({ demandaPontaKW: Number(target.value) })}
                startAdornment={<InputAdornment position="start">KW</InputAdornment>}
                type="number"
                value={demandaPontaKW}
              />
            </div>
          )}
          <div>
            <h6>Demanda fora ponta*</h6>
            <CustomInput
              disabled={shouldDisable}
              onChange={({ target }) => this.setState({ demandaForaPontaKW: Number(target.value) })}
              startAdornment={<InputAdornment position="start">KW</InputAdornment>}
              type="number"
              value={demandaForaPontaKW}
            />
          </div>

          <div className={classes.forceNewRowModifier}>
            <h6>Escolher energia total ou patamarizada</h6>
            <Select
              components={Animated}
              getOptionLabel={option => option.nome}
              getOptionValue={option => option.id}
              isDisabled={shouldDisable}
              noOptionsMessage={() => "Carregando..."}
              onChange={option => this.setState({ tipoDeEnergia: option })}
              options={tiposDeEnergia}
              placeholder=""
              value={tipoDeEnergia}
            />
          </div>

          {tipoDeEnergia.id === 'total' ? (
            <div className={classes.forceNewRowModifier}>
              <h6>Energia total*</h6>
              <CustomInput
                disabled={shouldDisable}
                onChange={({ target }) => this.setState({ energiaTotal: Number(target.value) })}
                type="number"
                value={energiaTotal}
              />
            </div>
            ) : ([
              <div className={classes.forceNewRowModifier} key="0">
                <h6>Energia ponta*</h6>
                <CustomInput
                  disabled={shouldDisable}
                  onChange={({ target }) => this.setState({ energiaPonta: Number(target.value) })}
                  type="number"
                  value={energiaPonta}
                />
              </div>,
              <div key="1">
                <h6>Energia fora ponta*</h6>
                <CustomInput
                  disabled={shouldDisable}
                  onChange={({ target }) => this.setState({ energiaForaPonta: Number(target.value) })}
                  type="number"
                  value={energiaForaPonta}
                />
              </div>,
            ])
          }

          <div className={classes.forceNewRowModifier}>
            <h6>Unidade*</h6>
            <Select
              components={Animated}
              getOptionLabel={option => option.nome}
              getOptionValue={option => option.id}
              isDisabled={shouldDisable}
              noOptionsMessage={() => "Carregando..."}
              onChange={option => this.setState({ unidadeEnergia: option })}
              options={filter(parametros.unidades, 'energia')}
              placeholder=""
              value={unidadeEnergia}
            />
          </div>
        </div>
      </div>
    );
  }

  getPrecos() {
    const { classes } = this.props;
    const { desconto, parametros, precoLivreAno, precoLivreAnoMais1, precoLivreAnoMais2, precoLivreAnoMais3 } = this.state;
    const { cnpjDados, loading } = this.state;

    if (isEmpty(desconto)) {
      return;
    }

    const shouldDisable = !cnpjDados || loading;
    const precos = parametros.precosEnergiaLivrePorDescontoEAno[desconto.id];
    const precosKeys = keys(precos);

    return (
      <div>
        <h3><b>Preços</b></h3>
        <div className={classes.outrosWrapper}>
          <div>
            <CustomInput
              disabled={shouldDisable}
              onChange={({ target }) => this.setState({ precoLivreAno: Number(target.value) })}
              startAdornment={<InputAdornment position="start">{precosKeys[0]}*</InputAdornment>}
              type="number"
              value={precoLivreAno}
            />
          </div>
          <div>
            <CustomInput
              disabled={shouldDisable}
              onChange={({ target }) => this.setState({ precoLivreAnoMais1: Number(target.value) })}
              startAdornment={<InputAdornment position="start">{precosKeys[1]}*</InputAdornment>}
              type="number"
              value={precoLivreAnoMais1}
            />
          </div>
          <div>
            <CustomInput
              disabled={shouldDisable}
              onChange={({ target }) => this.setState({ precoLivreAnoMais2: Number(target.value) })}
              startAdornment={<InputAdornment position="start">{precosKeys[2]}*</InputAdornment>}
              type="number"
              value={precoLivreAnoMais2}
            />
          </div>
          {precosKeys.length > 3 && (
            <div>
              <CustomInput
                disabled={shouldDisable}
                onChange={({ target }) => this.setState({ precoLivreAnoMais3: Number(target.value) })}
                startAdornment={<InputAdornment position="start">{precosKeys[3]}*</InputAdornment>}
                type="number"
                value={precoLivreAnoMais3}
              />
            </div>
          )}
        </div>
      </div>
    );
  }

  getOutros() {
    const { classes } = this.props;
    const { crescimentoAnualTarifaCativo, custoEncargos, percentualEnergiaProinfa, custoRepresentacaoMensal, previsaoIPCA, tarifaCCEEPorMWh } = this.state;
    const { cnpjDados, loading } = this.state;
    const shouldDisable = !cnpjDados || loading;

    return (
      <div>
        <h3><b>Outros</b></h3>
        <div className={classes.outrosWrapper}>
          <div>
            <h6>Energia Proinfa</h6>
            <CustomInput
              disabled={shouldDisable}
              onChange={({ target }) => this.setState({ percentualEnergiaProinfa: Number(target.value) })}
              startAdornment={<InputAdornment position="start">%</InputAdornment>}
              type="number"
              value={percentualEnergiaProinfa}
            />
          </div>
          <div>
            <h6>Tarifa CCEE</h6>
            <CustomInput
              disabled={shouldDisable}
              onChange={({ target }) => this.setState({ tarifaCCEEPorMWh: Number(target.value) })}
              startAdornment={<InputAdornment position="start">R$/MWh</InputAdornment>}
              type="number"
              value={tarifaCCEEPorMWh}
            />
          </div>
          <div>
            <h6>Encargos setoriais</h6>
            <CustomInput
              disabled={shouldDisable}
              onChange={({ target }) => this.setState({ custoEncargos: Number(target.value) })}
              startAdornment={<InputAdornment position="start">R$/MWh</InputAdornment>}
              type="number"
              value={custoEncargos}
            />
          </div>
          <div>
            <h6>Representação CCEE (mensal)</h6>
            <CustomInput
              disabled={shouldDisable}
              onChange={({ target }) => this.setState({ custoRepresentacaoMensal: Number(target.value) })}
              startAdornment={<InputAdornment position="start">R$</InputAdornment>}
              type="number"
              value={custoRepresentacaoMensal}
            />
          </div>
          <div>
            <h6>Previsão IPCA</h6>
            <CustomInput
              disabled={shouldDisable}
              onChange={({ target }) => this.setState({ previsaoIPCA: Number(target.value) })}
              startAdornment={<InputAdornment position="start">%</InputAdornment>}
              type="number"
              value={previsaoIPCA}
            />
          </div>
          <div>
            <h6>Crescimento Anual Tarifa Cativo</h6>
            <CustomInput
              disabled={shouldDisable}
              onChange={({ target }) => this.setState({ crescimentoAnualTarifaCativo: Number(target.value) })}
              startAdornment={<InputAdornment position="start">%</InputAdornment>}
              type="number"
              value={crescimentoAnualTarifaCativo}
            />
          </div>
        </div>
      </div>
    );
  }

  companyNotFound = () => {
    this.setState({
      cnpjDados: undefined,
      error: 'Nenhuma empresa encontrada',
      loading: false,
    });
  }

  handleSearch = selected => {
    if (!selected) return;

    let request;

    this.setState({ cnpjDados: undefined, loading: true });

    if (selected.id === "CATIVO") {
      request = getCativoInfo(removeNonDigits(selected.cnpj));
    } else {
      request = getCompanyInfo(selected.id);
    }

    request.then(({ data }) => {
      if (data && data.length === 0) {
        return this.companyNotFound();
      }

      const { categoriaCNAE, consumoMedioForaPontaMWMed, consumoMedioPontaMWMed, consumoMedioTotalMWMed, custoContabilizacao, custoRepresentacaoMensal, demandaForaPonta, demandaPonta, distribuidoraSugerida, modalidadeTarifaria, percentualEnergiaProinfa, subgrupo } = data;

      this.setState({
        categoriaCNAE,
        cnpjDados: data,
        custoEncargos: custoContabilizacao,
        custoRepresentacaoMensal,
        demandaForaPontaKW: demandaForaPonta,
        demandaPontaKW: demandaPonta,
        distribuidora: distribuidoraSugerida,
        energiaForaPonta: consumoMedioForaPontaMWMed,
        energiaPonta: consumoMedioPontaMWMed,
        energiaTotal: consumoMedioTotalMWMed,
        error: undefined,
        loading: false,
        modalidade: modalidadeTarifaria,
        percentualEnergiaProinfa: round(percentualEnergiaProinfa, 2),
        subgrupo,
      });
    }).catch(this.companyNotFound);
  }

  simularEconomia = () => {
    const {
      categoriaCNAE,
      cnpjDados,
      crescimentoAnualTarifaCativo,
      custoEncargos,
      demandaPontaKW,
      demandaForaPontaKW,
      desconto,
      distribuidora,
      energiaPonta,
      energiaForaPonta,
      energiaTotal,
      percentualEnergiaProinfa,
      custoRepresentacaoMensal,
      modalidade,
      precoLivreAno,
      precoLivreAnoMais1,
      precoLivreAnoMais2,
      precoLivreAnoMais3,
      previsaoIPCA,
      subgrupo,
      tarifaCCEEPorMWh,
      tipoDeEnergia,
      unidadeEnergia } = this.state;

    this.setState({ resultadoEconomia: undefined });

    let params = {
      idEmpresa: cnpjDados.id,
      idDistribuidora: distribuidora.id,
      subgrupo: subgrupo.id,
      modalidadeTarifaria: modalidade.id,
      categoriaCNAE: categoriaCNAE.id,
      desconto: desconto.id,
      energiaMensal: times(12, i => {
        let mensal = { mes: i + 1, unidadeEnergia: unidadeEnergia.id };

        if (tipoDeEnergia.id === 'total') {
          mensal.energiaTotal = energiaTotal;
        } else {
          mensal.energiaPonta = energiaPonta;
          mensal.energiaForaPonta = energiaForaPonta;
        }

        return mensal;
      }),
      demandaPontaKW,
      demandaForaPontaKW,
      percentualEnergiaProinfa,
      tarifaCCEEPorMWh,
      custoEncargos,
      custoRepresentacaoMensal,
      previsaoIPCA,
      crescimentoAnualTarifaCativo,
      precosEnergiaLivre: {
        precoLivreAno,
        precoLivreAnoMais1,
        precoLivreAnoMais2,
        precoLivreAnoMais3,
      },
    };

    return calcularEconomia(params)
      .then(res => {
        this.setState({ resultadoEconomia: res.data, simulando: false });
      })
      .catch(() => {
        this.setState({ simulando: false });
      });
  }

  btnSimularEconomia = () => {
    const { classes } = this.props;
    const { simulando } = this.state;

    if (isEmpty(this.state.desconto)) {
      return;
    }

    let shouldDisableBtn =
      !this.state.cnpjDados ||
      isEmpty(this.state.distribuidora) ||
      isEmpty(this.state.subgrupo) ||
      isEmpty(this.state.modalidade) ||
      isEmpty(this.state.categoriaCNAE) ||
      this.state.demandaForaPontaKW < 0 ||
      isEmpty(this.state.tipoDeEnergia) ||
      isEmpty(this.state.unidadeEnergia) ||
      !this.state.precoLivreAno ||
      !this.state.precoLivreAnoMais1 ||
      !this.state.precoLivreAnoMais2;

    if (this.state.tipoDeEnergia.id === 'total') {
      if (!this.state.energiaTotal) {
        shouldDisableBtn = true;
      }
    } else {
      if (!this.state.energiaPonta || !this.state.energiaForaPonta) {
        shouldDisableBtn = true;
      }
    }

    const precos = this.state.parametros.precosEnergiaLivrePorDescontoEAno[this.state.desconto.id];
    const precosKeys = keys(precos);
    // As vezes vem 4 anos as vezes 3, então não podemos checar sempre o quarto ano como obrigatório.
    if (precosKeys.length === 4 && !this.state.precoLivreAnoMais3) {
      shouldDisableBtn = true;
    }

    if (simulando) {
      return (
        <div className={classes.calcularButtonWrapper}>
          <BouncingLoader />
        </div>
      );
    } else {
      return ([
        <div className={classes.calcularButtonWrapper} key="0">
          <Button
            color="info"
            disabled={shouldDisableBtn}
            onClick={() => {
              this.setState({ simulando: true });
              this.simularEconomia();
            }}
          >
            Calcular
          </Button>
        </div>,
        shouldDisableBtn && (
          <p className={classes.requiredFieldsError} key="1">
            Contém campos obrigatórios ainda não preenchidos
          </p>
        ),
      ]);
    }
  }

  handleEntreEmContatoClick = () => {
    this.setState({ sending: true });
    const { email, nome, msg } = this.state;

    sendMessage({ email, nome, msg: `Quero ser livre. ${msg}` })
      .then(() => this.setState({
        emailSentMessage: "Mensagem enviada com sucesso, entraremos em contato em breve.",
        email: "",
        nome: "",
        msg: "",
        sending: false,
      }))
      .catch(() => this.setState({
        emailSentMessage: "Erro no envio da mensage, por favor tente novamente mais tarde.",
        sending: false,
      }));
  }

  render() {
    const { classes } = this.props;
    const { emailSentMessage, email, error, loading, msg, nome, sending, resultadoEconomia } = this.state;

    return (
      <GridContainer>
        <GridItem md={12} sm={12} xs={12}>
          <div className={classes.autosuggest}>
            <AutosuggestCNPJAsync
              onHandleSelected={this.handleSearch}
              placeholder="Buscar por CNPJ para calcular a economia"
            />
            {error && (
              <h3>{error}</h3>
            )}
            {loading && (
              <div className={classes.loading}>
                <LinearProgress />
              </div>
            )}
          </div>
          <ECCard
            content={
              <div>
                {this.getInfoContent()}
                {this.getEnergia()}
                {this.getPrecos()}
                {this.getOutros()}
                {this.btnSimularEconomia()}
                {resultadoEconomia && (
                  <div>
                    <ResultadoSimuladorCativoLivre resultadoEconomia={resultadoEconomia} />
                    <div>
                      <div className={classes.disclaimer}>
                        <h3><b>Deseja ser livre? Entre em contato</b></h3>
                        {/*<Hidden smDown>
                          <p>Ainda em dúvida? Envie uma mensagem e retornaremos o contato</p>
                          <p>o mais rápido possível. Ou <a href="cadastro">cadastre-se</a> agora e tenha acesso livre</p>
                          <p>durante <b>30 dias</b> para testar todas as nossas funcionalidades.</p>
                          <p>Só comece a pagar se satisfeito.</p>
                        </Hidden>*/}
                        <Hidden mdUp>
                          <p>Envie uma mensagem para se cadastrar na Energy Company, retornaremos o contato o mais rápido possível. Tenha acesso livre durante <b>30 dias</b> para testar todas as nossas funcionalidades. Só comece a pagar se satisfeito.</p>
                        </Hidden>
                      </div>
                      <div className={classes.form}>
                        <input
                          className={classes.inputText}
                          onChange={e => this.setState({ nome: e.target.value })}
                          placeholder="Nome"
                          type="text"
                          value={nome}
                        />
                        <input
                          className={classes.inputText}
                          onChange={e => this.setState({ email: e.target.value })}
                          placeholder="E-mail"
                          type="text"
                          value={email}
                        />
                        <textarea
                          className={classes.textarea}
                          onChange={e => this.setState({ msg: e.target.value })}
                          placeholder="Mensagem"
                          rows="5"
                          type="area"
                          value={msg}
                        />
                        {emailSentMessage ?
                          (
                            <p className={classes.emailSentMessage}>{emailSentMessage}</p>
                          ) : (
                            <div className={classes.sendButtonWrapper}>
                              <button
                                className={classes.button}
                                disabled={sending}
                                onClick={this.handleEntreEmContatoClick}
                              >
                                Enviar
                              </button>
                              {sending && <CircularProgress className={classes.circularProgress} size={24} />}
                            </div>
                          )
                        }
                      </div>
                    </div>
                  </div>
                )}
              </div>
            }
            icon={<AttachMoneyIcon />}
            title="Simulador de Economia"
          />
        </GridItem>
      </GridContainer>
    );
  }
}

Simulador.propTypes = {
  classes: PropTypes.object.isRequired,
};

export { Simulador as SimuladorComponent };
export default withStyles(simuladorStyle)(Simulador);



// WEBPACK FOOTER //
// ./src/views/Pages/SimuladoresPage.jsx